import React from "react";
import { FooterWrapper } from "./Footer.style";

const Footer = () => {
  return (
    <FooterWrapper>
      Made by Collin Fingar using React and styled-components
    </FooterWrapper>
  );
};

export default Footer;
